// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-sidebar-row {
  --au-sidebar-dot: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--admin-s3);
  width: 100%;
  min-height: 28px;
  padding: 0 var(--admin-s3) 0 calc(var(--admin-s3) - 2px);
  border: 0;
  border-left: 2px solid transparent;
  border-radius: var(--admin-radius-sm);
  background: transparent;
  color: var(--admin-text-secondary);
  text-align: left;
  transition: background var(--admin-transition-fast), border-color var(--admin-transition-fast), color var(--admin-transition-fast);
}

.au-sidebar-row__main {
  display: flex;
  align-items: center;
  gap: var(--admin-s3);
  min-width: 0;
}

.au-sidebar-row__dot {
  width: 6px;
  height: 6px;
  border-radius: var(--admin-radius-dot);
  background: var(--au-sidebar-dot);
  flex: 0 0 auto;
}

.au-sidebar-row__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--admin-text-sm);
  font-weight: var(--admin-font-weight-normal);
}

.au-sidebar-row__count {
  margin-left: auto;
  color: var(--admin-text-muted);
  font-size: var(--admin-text-xs);
  font-weight: var(--admin-font-weight-semibold);
  text-align: right;
}

.au-sidebar-row:hover {
  background: var(--admin-bg-hover);
  color: var(--admin-text-primary);
}

.au-sidebar-row.is-interactive {
  cursor: pointer;
}

.au-sidebar-row.is-active {
  background: var(--admin-bg-active);
  border-left-color: var(--admin-accent);
  color: var(--admin-text-primary);
}

.au-sidebar-row--critical {
  --au-sidebar-dot: var(--admin-status-critical);
}

.au-sidebar-row--signal {
  --au-sidebar-dot: var(--admin-status-signal);
}

.au-sidebar-row--ambient {
  --au-sidebar-dot: var(--admin-status-ambient);
}

.au-sidebar-row--ok {
  --au-sidebar-dot: var(--admin-status-ok);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminSidebarRow.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,wDAAwD;EACxD,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,kIAAkI;AACpI;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".au-sidebar-row {\n  --au-sidebar-dot: rgba(255, 255, 255, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--admin-s3);\n  width: 100%;\n  min-height: 28px;\n  padding: 0 var(--admin-s3) 0 calc(var(--admin-s3) - 2px);\n  border: 0;\n  border-left: 2px solid transparent;\n  border-radius: var(--admin-radius-sm);\n  background: transparent;\n  color: var(--admin-text-secondary);\n  text-align: left;\n  transition: background var(--admin-transition-fast), border-color var(--admin-transition-fast), color var(--admin-transition-fast);\n}\n\n.au-sidebar-row__main {\n  display: flex;\n  align-items: center;\n  gap: var(--admin-s3);\n  min-width: 0;\n}\n\n.au-sidebar-row__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: var(--admin-radius-dot);\n  background: var(--au-sidebar-dot);\n  flex: 0 0 auto;\n}\n\n.au-sidebar-row__label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--admin-text-sm);\n  font-weight: var(--admin-font-weight-normal);\n}\n\n.au-sidebar-row__count {\n  margin-left: auto;\n  color: var(--admin-text-muted);\n  font-size: var(--admin-text-xs);\n  font-weight: var(--admin-font-weight-semibold);\n  text-align: right;\n}\n\n.au-sidebar-row:hover {\n  background: var(--admin-bg-hover);\n  color: var(--admin-text-primary);\n}\n\n.au-sidebar-row.is-interactive {\n  cursor: pointer;\n}\n\n.au-sidebar-row.is-active {\n  background: var(--admin-bg-active);\n  border-left-color: var(--admin-accent);\n  color: var(--admin-text-primary);\n}\n\n.au-sidebar-row--critical {\n  --au-sidebar-dot: var(--admin-status-critical);\n}\n\n.au-sidebar-row--signal {\n  --au-sidebar-dot: var(--admin-status-signal);\n}\n\n.au-sidebar-row--ambient {\n  --au-sidebar-dot: var(--admin-status-ambient);\n}\n\n.au-sidebar-row--ok {\n  --au-sidebar-dot: var(--admin-status-ok);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
